import Avatar from "@pathwright/ui/src/components/avatar/Avatar"
import Button from "@pathwright/ui/src/components/button/Button"
import { usePathwrightContext } from "@pathwright/web/src/modules/pathwright/PathwrightContext"
import classnames from "classnames"
import { ConnectStores } from "lib/core/store"
import { TEACH } from "path/constants"
import PropTypes from "prop-types"
import AnaltyicsAvatarsStack from "./AnaltyicsAvatarsStack"
import "./PeopleHere.css"

const PeopleHere = (props, { mode }) => {
  let {
    offering,
    size,
    limit,
    analytics,
    inverted,
    className,
    hideAvatars,
    includeSelf
  } = props
  const { next_count, students_here } = analytics
  const { me: user } = usePathwrightContext()

  let visible = false
  if (offering) {
    const { analytics_visibility, permissions } = offering
    const { can_view_analytics } = permissions
    visible = mode < TEACH ? analytics_visibility > 5 : can_view_analytics
  }

  if (!visible) return null
  if (!next_count || next_count < 1) return null

  className = classnames("PeopleHere", className)

  const avatarSizeNumber = size === "small" ? 16 : 20
  const avatarSpacing = size === "small" ? -0.4 * avatarSizeNumber : 0
  const avatarSize = { number: avatarSizeNumber, unit: "px" }
  const avatarSpacingSize = { number: avatarSpacing, unit: "px" }

  let countLabel = includeSelf ? next_count - 1 : next_count
  if (includeSelf) {
    countLabel += " others"
  }
  countLabel += " here..."

  const users =
    students_here != null
      ? students_here.filter((here) => here.id !== user?.id)
      : undefined

  return (
    <Button
      className={className}
      styleType="blank"
      color="#888"
      size={size}
      inverted={inverted}
    >
      {includeSelf && next_count > 1 ? (
        <span className="PeopleHere__self">
          <Avatar user={user} size={avatarSize} />
          You and
        </span>
      ) : undefined}
      {!hideAvatars ? (
        <AnaltyicsAvatarsStack
          analytics={analytics}
          limit={limit}
          itemWidth={avatarSize}
          itemOffset={avatarSpacingSize}
        />
      ) : undefined}
      {(() => {
        if (includeSelf && next_count === 1) {
          return (
            <span className="PeopleHere__self">
              <Avatar user={user} size={avatarSize} />
              You are here...
            </span>
          )
        } else if (next_count > 0) {
          return <span>{countLabel}</span>
        }
      })()}
    </Button>
  )
}

PeopleHere.displayName = "PeopleHere"
PeopleHere.contextTypes = {
  mode: PropTypes.number
}

const mapStateToProps = function (state, ownProps) {
  const { item } = ownProps
  const { offering } = state.resourceStore.state
  const analytics =
    state.pathAnalyticsStore.request.getAnalyticsForItem(item.sync_source_id) ||
    {}

  return _.assign(
    {},
    {
      offering,
      analytics
    },
    ownProps
  )
}

const stores = [
  { store: "path", watch: false },
  { store: "pathAnalytics", watch: ["item_analytics"] },
  { store: "resource", watch: ["offering"] }
]

export default ConnectStores(PeopleHere, stores, {}, mapStateToProps)
